module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "dropdown"
  }, [_c('li', {
    class: {
      active: _vm.show === 'home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Home'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeShow('home')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('span', [_vm._v("  首页")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'topic'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Topic'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeShow('topic')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _c('span', [_vm._v("  专题")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.show === 'download'
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/download'
    },
    on: {
      "click": function($event) {
        _vm.changeShow('download')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _c('span', [_vm._v("  下载手机应用")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav-user"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/test"
    }
  }, [_c('i', {
    staticClass: "fa fa-font"
  }), _c('span', [_vm._v("  显示模式")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _c('span', [_vm._v("  登录")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "home",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "display"
    }
  }, [_c('router-view', {
    attrs: {
      "transition": "display",
      "transition-mode": "out-in"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightbar"
  }, [(!_vm.login_success) ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        params: {
          loginWay: 'login'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("登录")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        params: {
          loginWay: 'register'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("注册")])], 1) : _vm._e(), _vm._v(" "), (_vm.login_success == 'true') ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    },
    on: {
      "click": function($event) {
        _vm.changeLogin('login')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("个人信息")])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026907eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 57
// module chunks = 0